import { BaseModel } from "../base.model";

export class Qrange extends BaseModel {
  id: number;
  questionRangeGroupId: number;
  value: number | null;
  variantCount: number;
}
